import { useContext } from 'react';

import { AuthContext } from '@/context';
import type { AuthContextValue } from '@/types/authTypes';

const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};

export default useAuth;
